import type { GetServerSideProps } from 'next';

import { withFixedPageCommonProps } from '@/utils/fixedPage';

import { getFixedPageStaticProps } from '@/lib/commonPageStaticProps';
import { NewsLetterView } from '@/views/NewsLetterView/index';

export const getServerSideProps: GetServerSideProps = getFixedPageStaticProps(
  'newsletter/subscribe',
);
export default withFixedPageCommonProps(NewsLetterView);
